<template>
  <div class="mypage-dashboard-container">
    <div class="mypage-dashboard-container-item">
      <p>진행중인 설문</p>
      <h2>{{ this.surveyOngoing }}개</h2>
    </div>
    <div class="mypage-dashboard-container-line"></div>
    <div class="mypage-dashboard-container-item">
      <p>완료된 설문</p>
      <h2>{{ this.surveyDone }}개</h2>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { instanceWithAuth } from '../../api/index'
export default {
  name: 'MyPageDashboard',
  data() {
    return {
      surveyOngoing : 0,
      surveyDone : 0
    }
  },

  mounted(){
    this.fetchDashBoard()
  },

  methods : {
    async fetchDashBoard(){
      if(this.$store.state.isLoggedIn){
          try {
            const response = await axios.post("https://gosurveasy.co.kr/survey/mypage",
          {
            email : this.$store.state.currentUser.email
          })
          this.surveyOngoing = response.data.surveyOngoing
          this.surveyDone = response.data.surveyDone
        } catch (error) {
          console.log(error)
        }
      }else
      {
        try {
          const response = await instanceWithAuth.get('/survey/mypage')
          //console.log(response)
          this.surveyOngoing = response.data.surveyOngoing
          this.surveyDone = response.data.surveyDone
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
}
</script>

<style>
.mypage-dashboard-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 0 16px;
  padding: 20px 0;
  box-sizing: border-box;
  align-items: center;
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-sm);
  font-family: var(--font-sans);
}
.mypage-dashboard-container-item {
  flex: 1;
  margin: auto;
  padding: 10px;
  text-align: center;
}
.mypage-dashboard-container-item p {
  margin: 0 0 6px;
  font-size: 13px;
  color: var(--text-muted);
}
.mypage-dashboard-container-item h2 {
  margin: 0;
  font-size: 24px;
  font-weight: var(--font-weight-bold);
  color: var(--green-600);
}
.mypage-dashboard-container-line {
  width: 1px;
  height: 40px;
  background-color: var(--ink-100);
}
</style>